import { render, staticRenderFns } from "./TaskItemDetailPrice.component.vue?vue&type=template&id=5a09a558&scoped=true&"
import script from "./TaskItemDetailPrice.component.vue?vue&type=script&lang=js&"
export * from "./TaskItemDetailPrice.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemDetailPrice.component.vue?vue&type=style&index=0&id=5a09a558&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09a558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
